import { render, staticRenderFns } from "./PublicAgenda.vue?vue&type=template&id=6a42f59f&"
import script from "./PublicAgenda.vue?vue&type=script&lang=js&"
export * from "./PublicAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports